import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/home' // 当访问根路径时，重定向到 /home
    },
    {
        path: '/home',
        name: 'main',
        component: () => import('@/views/MainView.vue'),
        redirect: () => {
            // 根据用户等级动态重定向到不同的首页
            const level = store.state.userLevel;
            switch (level) {
                case 0:
                    return { name: 'UserView' }; // 普通用户首页
                case 1:
                    return { name: 'HomeView' }; // 超级管理员页面
                default:
                    return { name: 'UserView' }; // 默认跳转到普通用户首页
            }
        },
        children: [
            {
                path: 'admin-home',
                name: 'HomeView',
                component: () => import('@/views/HomeView.vue') // PC端 超级管理员页面
            },
            {
                path: 'mobile-home', // 移动端首页
                name: 'MobileHome',
                component: () => import('@/views/MobileHome.vue')
            },
            {
                path: 'user-home',  // 普通用户首页
                name: 'UserView',
                component: () => import('@/views/UserView.vue')
            },
            {
                path: 'order',  // 订单页面
                name: 'order',
                component: () => import('@/views/order/Order.vue')
            },
            {
                path: 'resume', // 简历页面
                name: 'resume',
                component: () => import('@/views/resume/Resume.vue')
            },
            {
                path: 'certification', // 认证页面
                name: 'certification',
                component: () => import('@/views/certification/Certification.vue')
            },
            {
                path: 'orther', // 轮播图页面
                name: 'orther',
                component: () => import('@/views/Orther.vue')
            },
            {
                path: 'usermanage', // 管理员页面
                name: 'usermanage',
                component: () => import('@/views/usermanage/Usermanage.vue')
            },
            {
                path: 'userPoints', // 管理用户积分
                name: 'userPoints',
                component: () => import('@/views/userPoints/userPoints.vue')
            },
            {
                path: 'getMoneyRecord', // 管理用户积分
                name: 'getMoneyRecord',
                component: () => import('@/views/getMoneyRecord/getMoneyRecord.vue')
            }
            
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/LoginView.vue')
    }
];


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');
    const userLevel = localStorage.getItem('userLevel'); // 从 localStorage 获取用户级别
    const isMobile = window.innerWidth <= 768;


    
    if (!token) {
        // 如果没有 token，强制跳转到登录页
        if (to.name !== 'login') {
            next({ name: 'login' });
        } else {
            next(); // 如果是登录页，允许访问
        }
    } else {
        // 已登录状态处理
        if (isMobile) {
            // 移动设备的访问控制
            if (to.name === 'MobileHome') {
                next(); // 允许访问移动端首页
            } else if (from.name !== 'MobileHome') {
                // 从非移动端首页跳转到其他页面时，重定向到移动端首页
                next({ name: 'MobileHome' });
            } else {
                next(); // 允许访问其他移动端页面
            }
        } else {
            // PC 端的访问控制
            if (userLevel === '0' && to.name === 'HomeView') {
                // 普通用户尝试访问超级管理员页面，重定向到普通用户页面
                next({ name: 'UserView' });
                // next({ name: 'HomeView' });
            } else if (userLevel !== '0' && to.name === 'UserView') {
                // 超级管理员尝试访问普通用户页面，重定向到管理员页面
                next({ name: 'HomeView' });
            } else {
                next(); // 允许访问其他页面
            }
        }
    }
});



export default router;
